import { FunctionComponent, ReactNode } from "react";

export type InputLabelProps = {
  children?: ReactNode | ReactNode[];
};

export const InputLabel: FunctionComponent<InputLabelProps> = ({ children }: InputLabelProps) => {
  return <div className="font-bold mt-5">{children}</div>;
};
